import React, { useState, useEffect, useRef, useCallback } from 'react'
import { getUserDetails } from '../Utility/AsyncStorage';
import axios from "axios";
import { showToast } from './Toast';
import "../output.css"
import "../Styles/Modal.css"
import { useLocation, useNavigate } from "react-router-dom";
import { Tooltip } from 'react-tooltip'
// import Footer from './Footer';
import Loader from './Loader';
import Report from '../Utility/Report'
import * as FileSaver from 'file-saver';


const UserTable = ({ data, handleShiftList, handleEdit, onView, downloadCompReport, is_Warrenty, isActiveDevice, userdetails, onUpdateBatchData }) => {
  const navigate = useNavigate();

  const downloadGyroReport = async (device_id) => {
    showToast("Report Processing Started, Please Wait", 1000, "green");
    try {
      let url = "https://itlapi.flovation.in/machine/fetchPlcDataForReportGyroData";
      let body = {
        device_id: device_id,
      }

      await axios.post(url, body, {
        headers: {
          'authorization': `${userdetails.access_token}`
        },
        responseType: 'blob',
      }).then(response => {
        if (response.status === 200) {
          var blob = new Blob([response.data], {
            type: 'application/vnd.ms-excel',
          });
          let fileDate = new Date()
          var name = `ITL_GYRO_Machine_Report_${1000 + Number(device_id)}.xlsx`;
          FileSaver.saveAs(blob, name);
          showToast("Download Report successfully", 3000, "green");
        }
      }).catch(error => {
        if (error.response.status === 403) {
          showToast("Session Time Out", 3000, "red");
          navigate("/")
        }
        else
          console.log("downloadGyroReport else", error)
      })
    } catch (error) {
      console.log("downloadGyroReport", error)
    }
  }



  return (
    <div className="p-2 w-full mx-auto" style={{ height: "fit-content", maxHeight: "75vh", overflowY: "scroll", scrollbarWidth: "thin" }}>
      <div className="overflow-hidden bg-white shadow-md rounded-xl table-scroll">
        <table className="w-full border-collapse">
          {/* Table Header */}
          <thead >
            <tr className="bg-gray-200 text-black text-sm capitalize border-b table-header-group">
              <th className="px-3 py-3 text-left">s.no</th>

              <th className="px-3 py-3 text-left">
                Device Status
              </th>

              <th className="px-3 py-3 text-left">
                Machine serial no
              </th>

              <th className="px-3 py-3 text-left">
                Machine model
              </th>

              <th
                className="px-3 py-3 text-left cursor-pointer"
                data-tooltip-id="my-tooltip-add"
                data-tooltip-content="ID of the device paired with the machine."
              >
                Device
              </th>

              <th className="px-3 py-3 text-left">
                Customer name
              </th>

              <th
                className="px-3 py-3 text-left cursor-pointer"
                data-tooltip-id="my-tooltip-add"
                data-tooltip-content="Current operating state of the machine (Running, Idle, or Stopped)."
              >
                Machine status
              </th>

              <th
                className="px-3 py-3 text-left cursor-pointer"
                data-tooltip-id="my-tooltip-add"
                data-tooltip-content="Last time the machine sent a message to the server."
              >
                Active time
              </th>

              <th
                className="px-3 py-3 text-left cursor-pointer"
                data-tooltip-id="my-tooltip-add"
                data-tooltip-content="Indicates whether the machine has generated any alerts."
              >
                Alert status
              </th>

              <th
                className="px-3 py-3 text-left cursor-pointer"
                data-tooltip-id="my-tooltip-add"
                data-tooltip-content="Last time the machine generated an alert."
              >
                Alert Time
              </th>

              <th
                className="px-3 py-3 text-left cursor-pointer"
                data-tooltip-id="my-tooltip-add"
                data-tooltip-content="Physical location where the machine is installed."
              >
                Location
              </th>

              <th
                className="px-3 py-3 text-left cursor-pointer"
                data-tooltip-id="my-tooltip-add"
                data-tooltip-content="Date when the machine was commissioned."
              >
                Warranty
              </th>

              <th className="px-3 py-3 text-center">
                Action
              </th>
            </tr>
          </thead>

          {/* Table Body */}
          <tbody className="text-gray-700 text-sm">
            {data.map((company, index) => (
              <tr
                key={index}
                className="border-b hover:bg-gray-50 transition company-table-block"
                onClick={() => navigate("/dashboard", { state: company.machine_id })}
              >
                <td className="px-3 py-3text-pink-500 font-medium text-center"><span>sno</span>{index + 1}</td>
                <td className="px-3 py-2"><span>Device Status</span>{isActiveDevice(company.stats[0]?.machinesLastStatus)}</td>
                <td className="px-3 py-3"><span>Machine Serial Number</span>{company.Machine_Serial_Number}</td>
                <td className="px-3 py-3"><span>Machine Model</span>{company.Machine_Model}</td>
                <td className="px-3 py-3"><span>Device</span>{1000 + parseInt(company.device_id)}</td>
                <td className="px-3 py-3"><span>Client</span>{company.Client_Name}</td>
                <td className="px-3 py-3"><span>Status</span>{company.stats[0].machinesLastStatus}</td>
                <td className="px-3 py-3"><span>Active Time</span>{company.stats[0].machinesLastActiveTime}</td>
                <td className="px-3 py-3"><span>Machine Alert</span>{company.stats[0].currentlyMachinesOnAlert}</td>
                <td className="px-3 py-3"><span>alert Time</span>{company.stats[0].lastMachinesOnAlertTime}</td>
                <td className="px-3 py-3"><span>Location</span>{company.location}</td>
                <td className="px-3 py-3"><span>Warrenty Status</span>{is_Warrenty(company.Machine_Commissioning_Date)}</td>

                <td className=" text-lg items-center text-center actionButtons">
                  {
                    (userdetails.role == "SUPER ADMIN" || userdetails.role == "SUB ADMIN") &&
                    <>
                      <i
                        className="fas fa-clock px-3"
                        data-tooltip-id="my-tooltip-shift"
                        data-tooltip-content="shift"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleShiftList(company.machine_id);
                        }}
                      ></i>

                      <i
                        className="fa fa-edit text-[10px]"
                        data-tooltip-id="my-tooltip-edit"
                        data-tooltip-content="Edit"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleEdit(company);
                        }}
                      ></i>

                      <i
                        className="fa fa-sitemap text-[10px] px-3"
                        data-tooltip-id="my-tooltip-add"
                        data-tooltip-content="Assign Device"
                        onClick={(e) => {
                          e.stopPropagation(); // Prevent row click event
                          onView(company);
                        }}
                      ></i></>}
                  {
                    company.comp_num == null ? null :
                      <i style={{ padding: "0 5px" }}
                        data-tooltip-id="my-tooltip-report"
                        data-tooltip-content="Download Report"
                        className="fa fa-download text-[15px]"
                        onClick={(e) => {
                          e.stopPropagation(); // Prevent row click event
                          downloadCompReport(company)
                        }}
                      ></i>
                  }

                  {
                    userdetails.comp_num != 11 ? null :
                      <i style={{ padding: "0 5px" }}
                        data-tooltip-id="my-tooltip-acc-report"
                        data-tooltip-content="Download Gyro Report"
                        className="fa fa-chart-line text-[15px]"
                        onClick={(e) => {
                          e.stopPropagation(); // Prevent row click event
                          downloadGyroReport(company.device_id)
                        }}
                      ></i>
                  }

                  {
                    userdetails.comp_num != 11 || company.iot_enabled != "Y" ? null :
                      <i style={{ padding: "0 5px" }}
                        data-tooltip-id="my-tooltip-update-device"
                        data-tooltip-content="Update Batch Data"
                        className="fa fa-th-large text-[15px]"
                        onClick={(e) => {
                          e.stopPropagation(); // Prevent row click event
                          onUpdateBatchData(company)
                        }}
                      ></i>
                  }

                  <Tooltip id="my-tooltip-add" />
                  <Tooltip id="my-tooltip-edit" />
                  <Tooltip id="my-tooltip-report" />
                  <Tooltip id="my-tooltip-shift" />
                  <Tooltip id="my-tooltip-acc-report" />
                  <Tooltip id="my-tooltip-update-device" />
                </td>

              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

function debounce(func, delay) {
  let timeoutId;

  return (...args) => {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => func(...args), delay);
  };
}

function Machine() {
  let empty_machine_data = {
    machine_name: "",
    setup_make: "",
    HMI_ID: "",
    Index_Servo_Drive: "",
    Index_Servo_Motor: "",
    Feed_Servo_Drive: "",
    Feed_Servo_Motor: "",
    PLC: "",
    Motion_Module: "",
    Input_Module: "",
    Output_Module: "",
    Analog_Module: "",
    VFD: "",
    Machine_Model: "",
    Machine_Serial_Number: "",
    Machine_Commissioning_Date: "",
    Machine_Dispatch_Date: "",
    location: ""
  }

  const [downloadReportState, setDownloadReportState] = useState(false)
  const [loaderState, setLoaderState] = useState(true);
  const location = useLocation();
  const userdetails = getUserDetails()
  const navigate = useNavigate();
  let RowData = useRef([])

  const [deviceId, setDeviceId] = useState(location?.state?.from == "device" ? location.state.device_id : undefined)

  const [deviceOption, setDeviceOption] = useState([])
  const [selectedDevice, setSelectedDevice] = useState()
  const [deviceAssignState, setDeviceAssignState] = useState(false)
  const [machineDetails, setMachineDetails] = useState([])

  const compNum = useRef(location?.state?.from == "device" ? undefined : location?.state?.from == "company" ? location.state?.comp_num : userdetails.role == "SUPER ADMIN" ? undefined : userdetails.role == "REGIONAL ADMIN" ? userdetails.assigned_companies : userdetails.comp_num);

  const [MachineList, setMachineList] = useState([])
  const [machineShow, setmacineShow] = useState(false)
  const [formData, setFormData] = useState(empty_machine_data);

  const [ma_id, setMa_id] = useState(undefined);
  const [shiftData, setShiftData] = useState([]);
  const [showShiftData, setShowShiftData] = useState(false);

  const [currentSection, setCurrentSection] = useState('machine');

  const [isExpanded, setIsExpanded] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');

  const handleIconClick = () => {
    setIsExpanded(true);
  };



  const handleDeviceAdd = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const getMachineList = async (searchTerm) => {
    try {

      setMachineList([])

      let url = "https://itlapi.flovation.in/machine/fetchMachineDetails";
      let body = {
        device_id: deviceId,
        stats_flag: 1,
        search: searchTerm ?? undefined,
        comp_num: compNum.current
      }

      // console.log("detdevice body", body)
      await axios.post(url, body, {
        headers: {
          'authorization': `${userdetails.access_token}`
        },
      }).then(response => {

        if (response.status === 200) {
          setLoaderState(false)
          if (response.data.statusCode === 0) {
            console.log("getMachineList", response.data)
            setMachineList(response.data.list)
          }
          else {
            console.log("getMachineList", response.data.msg)
            showToast(response.data.msg, 3000, "red");
          }

        }

        else {
          showToast(response.data.msg, 3000, "red");
        }

      }).catch(error => {
        console.log("getMachineList", error)
        if (error.response.status === 403) {
          console.log("companiesList if", error)
          showToast("Session Time Out", 3000, "red");
          navigate("/")
        }
        else
          console.log("companiesList else", error)
      })
    } catch (error) {
      console.log("getMachineList", error)
    }
  }

  const handleSubmitmachine = async (type) => {
    console.log("formData : ", type, " , ", formData)

    const requiredFields = {
      1: ["machine_name", "Machine_Model", "Machine_Serial_Number", "Machine_Dispatch_Date", "location"],
      2: ["setup_make", "HMI_ID", "Index_Servo_Drive", "Index_Servo_Motor", "Feed_Servo_Drive", "Feed_Servo_Motor", "PLC", "Motion_Module", "Input_Module", "Output_Module", "Analog_Module", "VFD"],
      3: ["Machine_Commissioning_Date"]
    };

    const keys = requiredFields[type] || requiredFields.default;

    const isMissing = keys.some((key) => {
      return String(formData[key] || "").replace(/\s/g, '') === "";
    });

    console.log(type, isMissing)
    if (isMissing) {
      showToast("Please fill all fields", 3000, "red");
      return;
    }



    try {

      let url = "https://itlapi.flovation.in/machine/insertMachineDetails";
      let body = {
        device_id: formData.device_id,
        machine_id: formData.machine_id,
        HMI_ID: formData.HMI_ID,
        Index_Servo_Drive: formData.Index_Servo_Drive,
        Index_Servo_Motor: formData.Index_Servo_Motor,
        Feed_Servo_Drive: formData.Feed_Servo_Drive,
        Feed_Servo_Motor: formData.Feed_Servo_Motor,
        PLC: formData.PLC,
        Motion_Module: formData.Motion_Module,
        Input_Module: formData.Input_Module,
        Output_Module: formData.Output_Module,
        Analog_Module: formData.Analog_Module,
        VFD: formData.VFD,
        Machine_Serial_Number: formData.Machine_Serial_Number,
        Machine_Commissioning_Date: formData.Machine_Commissioning_Date,
        machine_name: formData.machine_name,
        setup_make: formData.setup_make,
        Machine_Dispatch_Date: formData.Machine_Dispatch_Date,
        location: formData.location,
        Machine_Model: formData.Machine_Model
      }

      console.log("detdevice body", body)
      await axios.post(url, body, {
        headers: {
          'authorization': `${userdetails.access_token}`
        },
      }).then(response => {

        if (response.status === 200) {

          if (response.data.statusCode === 0) {
            console.log("handleSubmitmachine", response.data.list)
            showToast(response.data.msg, 3000, "green")
            getMachineList();
            setFormData(empty_machine_data)
            setmacineShow(false);
            setCurrentSection('machine')
          }
          else {
            console.log("handleSubmitmachine", response.data.msg)
            showToast(response.data.msg, 3000, "red");
            setFormData(empty_machine_data)
            setmacineShow(false);
          }

        }

        else {
          showToast(response.data.msg, 3000, "red");
          setFormData(empty_machine_data)
          setmacineShow(false);

        }

      }).catch(error => {
        console.log("handleSubmitmachine", error)

        if (error.response.status === 403) {
          console.log("handleSubmitmachine if", error)
          showToast("Session Time Out", 3000, "red");
          navigate("/")
        }
        else
          console.log("handleSubmitmachine else", error)
        setFormData(empty_machine_data)
        setmacineShow(false);
      })
    } catch (error) {
      console.log("handleSubmitmachine", error)
      setFormData(empty_machine_data)
      setmacineShow(false);
    }
  }

  const handleEdit = (item) => {
    setFormData(item)
    setmacineShow(true);
  }

  const handleShiftList = (m_id) => {
    setMa_id(m_id);
    fetchMachineShift(m_id);
    setShowShiftData(true);
  }

  const handleTimeChange = (index, field, value) => {
    const updatedShifts = [...shiftData];
    updatedShifts[index][field] = value;
    setShiftData(updatedShifts);
  };

  const addShift = () => {
    setShiftData([...shiftData, { start_time: "00:00:00", end_time: "00:00:00" }]);
  };

  const deleteShift = (index) => {
    const updatedShifts = shiftData.filter((_, i) => i !== index);
    setShiftData(updatedShifts);
  };

  const fetchMachineShift = async (m_id) => {
    try {
      setShiftData([])
      let url = "https://itlapi.flovation.in/machine/fetchMachineShift";
      let body = {
        machine_id: m_id
      }

      await axios.post(url, body, {
        headers: {
          'authorization': `${userdetails.access_token}`
        },
      }).then(response => {

        if (response.status === 200) {

          if (response.data.statusCode === 0) {
            console.log("UnpairDeviceList", response.data.op)
            setShiftData(response.data.op)
          }
          else {
            console.log("UnpairDeviceList", response.data.msg)
            showToast(response.data.msg, 3000, "red");
          }

        }

        else {
          showToast(response.data.msg, 3000, "red");
        }

      }).catch(error => {
        if (error.response.status === 403) {
          console.log("UnpairDeviceList if", error)
          showToast("Session Time Out", 3000, "red");
          navigate("/")
        }
        else
          console.log("UnpairDeviceList else", error)
      })
    } catch (error) {
      console.log("UnpairDeviceList", error)
    }
  }

  const updateMachineShift = async () => {
    try {
      let url = "https://itlapi.flovation.in/machine/insertMachineShift";

      let body = {
        machine_id: ma_id,
        shift_array: shiftData
      }

      setShiftData([])
      setMa_id(undefined)
      setShowShiftData(false)

      await axios.post(url, body, {
        headers: {
          'authorization': `${userdetails.access_token}`
        },
      }).then(response => {

        if (response.status === 200) {

          if (response.data.statusCode === 0) {
            // console.log("UnpairDeviceList", response.data.op)
            setShiftData([])
          }
          else {
            console.log("UnpairDeviceList", response.data.msg)
            showToast(response.data.msg, 3000, "red");
          }

        }

        else {
          showToast(response.data.msg, 3000, "red");
        }

      }).catch(error => {
        if (error.response.status === 403) {
          console.log("UnpairDeviceList if", error)
          showToast("Session Time Out", 3000, "red");
          navigate("/")
        }
        else
          console.log("UnpairDeviceList else", error)
      })
    } catch (error) {
      console.log("UnpairDeviceList", error)
    }
  }

  const handleView = (item) => {
    // console.log("handleView", item)
    setDeviceAssignState(true)
    // setAssignDevice((prev) => ({
    //   ...prev,
    //   comp_num: item.comp_num,
    // }));
    setMachineDetails(item)
  }

  const UnpairDeviceList = async () => {
    try {

      let url = "https://itlapi.flovation.in/device/fetchDeviceTobeAssignedInMachine";
      let body = {}

      await axios.post(url, body, {
        headers: {
          'authorization': `${userdetails.access_token}`
        },
      }).then(response => {

        if (response.status === 200) {

          if (response.data.statusCode === 0) {
            // console.log("UnpairDeviceList", response.data.op)
            setDeviceOption(response.data.op)

          }
          else {
            // console.log("UnpairDeviceList", response.data.msg)
            // showToast(response.data.msg, 3000, "red");
          }

        }

        else {
          showToast(response.data.msg, 3000, "red");
        }

      }).catch(error => {
        if (error.response.status === 403) {
          console.log("UnpairDeviceList if", error)
          showToast("Session Time Out", 3000, "red");
          navigate("/")
        }
        else
          console.log("UnpairDeviceList else", error)
      })
    } catch (error) {
      console.log("UnpairDeviceList", error)
    }
  }

  const handlepairDevice = (e) => {
    setSelectedDevice(e.target.value);

  }

  const submitAssignDevice = async () => {
    console.log("submitAssignDevice", selectedDevice, machineDetails.machine_id)
    try {

      let url = "https://itlapi.flovation.in/machine/assignDeviceToMachine";
      let body = {
        machine_id: machineDetails.machine_id,
        device_id: selectedDevice
      }

      console.log("detdevice body", body)
      await axios.post(url, body, {
        headers: {
          'authorization': `${userdetails.access_token}`
        },
      }).then(response => {

        if (response.status === 200) {

          if (response.data.statusCode === 0) {
            // console.log("pairMachine", response.data.list)
            showToast(response.data.msg, 3000, "green");
            setDeviceAssignState(false)
            setMachineDetails([])
            getMachineList()
          }
          else {
            console.log("pairMachine", response.data.msg)
            showToast(response.data.msg, 3000, "red");
          }

        }

        else {
          showToast(response.data.msg, 3000, "red");
        }

      }).catch(error => {
        console.log("pairMachine", error)
        if (error.response.status === 403) {
          console.log("pairMachine if", error)
          showToast("Session Time Out", 3000, "red");
          navigate("/")
        }
        else
          console.log("pairMachine else", error)
      })
    } catch (error) {
      console.log("pairMachine", error)
    }
  }

  const downloadCompReport = (item) => {
    RowData.current = item
    setDownloadReportState(true)
    // downloadReport()
  }

  const handleCloseModal = () => {
    setDownloadReportState(false);
  };


  // Write-time registers: used when we submit batch updates to the PLC
  const registerMap = {};
  for (let i = 1; i <= 10; i++) {
    const base = 3100 + (i - 1) * 10;
    registerMap[i] = {
      set_quantity: `D${base + 2}`,
      cut_length: `D${base}`,
    };
  }

  // Read-time registers: used to prefill the form from the machine's last
  // reported plc_data (these are the "actual" registers the machine reads
  // from after our write registers above are buffered/consumed)
  const readRegisterMap = {
    1: { cut_length: "D1714", set_quantity: "D1716" },
    2: { cut_length: "D1724", set_quantity: "D1726" },
    3: { cut_length: "D1734", set_quantity: "D1736" },
    4: { cut_length: "D1744", set_quantity: "D1746" },
    5: { cut_length: "D1754", set_quantity: "D1756" },
    6: { cut_length: "D1764", set_quantity: "D1766" },
    7: { cut_length: "D1774", set_quantity: "D1776" },
    8: { cut_length: "D1784", set_quantity: "D1786" },
    9: { cut_length: "D1794", set_quantity: "D1796" },
    10: { cut_length: "D1804", set_quantity: "D1806" },
  };

  const emptyBatchData = Array.from({ length: 10 }, (_, idx) => ({
    batch: idx + 1,
    cut_length: "",
    set_quantity: "",
  }));

  const [batchUpdateState, setBatchUpdateState] = useState(false);
  const [batchUpdateDevice, setBatchUpdateDevice] = useState(null);
  const [batchUpdateMachineId, setBatchUpdateMachineId] = useState(null);
  const [batchFormData, setBatchFormData] = useState(emptyBatchData);
  const [readLoop, setReadLoop] = useState(1);

  // Material Diameter (D3206), PTL / per-tooth-load (D3208), Cutter Speed (D3210)
  // Rule: zero allowed, float/decimal allowed, negative NOT allowed
  const [materialDiameter, setMaterialDiameter] = useState("");
  const [ptl, setPtl] = useState("");
  const [cutterSpeed, setCutterSpeed] = useState("");

  const resetBatchExtraFields = () => {
    setMaterialDiameter("");
    setPtl("");
    setCutterSpeed("");
  };

  const handleUpdateBatchData = async (company) => {
    setBatchUpdateDevice(company.device_id);
    setBatchUpdateMachineId(company.machine_id);
    setBatchFormData(emptyBatchData);
    setReadLoop(1);
    resetBatchExtraFields();
    setBatchUpdateState(true);

    try {
      let url = "https://itlapi.flovation.in/machine/fetchPlcLastData";
      let body = { machine_id: company.machine_id };

      const response = await axios.post(url, body, {
        headers: { 'authorization': `${userdetails.access_token}` },
      });

      if (response.status === 200 && response.data.statusCode === 0) {
        const record = response.data.list && response.data.list[0];
        const plcDataStr = record?.plc_data;

        // only prefill if plc_data actually has content
        if (plcDataStr && plcDataStr.length > 0) {
          const plcData = JSON.parse(plcDataStr);

          const prefilled = Array.from({ length: 10 }, (_, idx) => {
            const batchNum = idx + 1;
            const regs = readRegisterMap[batchNum];
            const cutVal = plcData[regs.cut_length];
            const qtyVal = plcData[regs.set_quantity];
            return {
              batch: batchNum,
              cut_length: cutVal !== undefined && cutVal !== null ? String(cutVal) : "",
              set_quantity: qtyVal !== undefined && qtyVal !== null ? String(qtyVal) : "",
            };
          });

          setBatchFormData(prefilled);
          setCutterSpeed(plcData.D172);
          setPtl(plcData.D2406);
        }
      } else if (response.status === 200) {
        console.log("handleUpdateBatchData", response.data.msg)
      }
    } catch (error) {
      console.log("handleUpdateBatchData - prefill", error);
      if (error.response?.status === 403) {
        showToast("Session Time Out", 3000, "red");
        navigate("/");
      }
      // fall back silently to the empty form if prefill fails
    }
  };

  const clampToRange = (value, min, max) => {
    if (value === "") return "";
    const num = Number(value);
    if (isNaN(num)) return "";
    if (num < min) return String(min);
    if (num > max) return String(max);
    return value;
  };

  // Allows zero and decimal/float values, blocks negative numbers.
  // Also tolerates partial typing of a decimal (e.g. "1.", "0.")
  const clampNonNegativeFloat = (value) => {
    if (value === "") return "";
    if (!/^\d*\.?\d*$/.test(value)) {
      // reject anything that isn't digits/decimal point (e.g. "-", letters)
      return undefined;
    }
    if (value === ".") return value; // let them keep typing
    const num = Number(value);
    if (isNaN(num)) return "";
    if (num < 0) return "0"; // negative not allowed
    return value;
  };

  const handleFloatFieldChange = (setter) => (rawValue) => {
    const next = clampNonNegativeFloat(rawValue);
    if (next === undefined) return; // ignore invalid keystrokes
    setter(next);
  };

  const handleBatchFieldChange = (index, field, value) => {
    // Cut Length: clamp to 1-999999. Set Quantity: clamp to 0-999999.
    let nextValue = value;
    if (field === "cut_length") nextValue = clampToRange(value, 1, 5000);
    if (field === "set_quantity") nextValue = clampToRange(value, 0, 999999);

    setBatchFormData((prev) => {
      const updated = [...prev];
      updated[index] = { ...updated[index], [field]: nextValue };
      return updated;
    });
  };

  const handleReadLoopChange = (value) => {
    // Actual Loop is not allowed to be set to 0
    if (value !== "" && Number(value) === 0) {
      showToast("Actual Loop cannot be 0", 2000, "red");
      return;
    }
    setReadLoop(value);
  };

  const handleReadPTLChange = (value) => {
    // Actual Loop is not allowed to be set to 0
    setPtl(value);
  };

  const handleReadSawSpeedChange = (value) => {
    // Actual Loop is not allowed to be set to 0
    if (value !== "" && Number(value) === 0) {
      showToast("Saw Speed cannot be 0", 2000, "red");
      return;
    }
    setCutterSpeed(value);
  };

  const deleteBatchRow = (index) => {
    // only the last row in the sequence can be removed
    if (index !== batchFormData.length - 1) {
      showToast("You can only remove the last batch first", 2500, "red");
      return;
    }
    setBatchFormData((prev) => prev.filter((_, i) => i !== index));
  };

  const submitBatchUpdate = async () => {
    try {
      // Actual Loop can not be zero
      if (readLoop === "" || Number(readLoop) === 0) {
        showToast("Actual Loop cannot be 0", 3000, "red");
        return;
      }

      // Cut Length must be 1-5000, Set Quantity must be 0-5000
      const hasInvalidCutLength = batchFormData.some(
        (row) => row.cut_length !== "" && (Number(row.cut_length) < 0 || Number(row.cut_length) > 5001)
      );
      if (hasInvalidCutLength) {
        showToast("Cut Length must be between 1 and 5000", 3000, "red");
        return;
      }
      const hasInvalidSetQuantity = batchFormData.some(
        (row) => row.set_quantity !== "" && (Number(row.set_quantity) < 0 || Number(row.set_quantity) > 999999)
      );
      if (hasInvalidSetQuantity) {
        showToast("Set Quantity must be between 0 and 999999", 3000, "red");
        return;
      }

      if (materialDiameter !== "" && Number(materialDiameter) < 0) {
        showToast("Material Diameter cannot be negative", 3000, "red");
        return;
      }

      if (cutterSpeed !== "" && (Number(cutterSpeed) < 20 || Number(cutterSpeed) > 201)) {
        showToast("Saw Speed must be lie between 20 to 200 mpm", 2000, "red");
        return;
      }

      if (ptl !== "" && (Number(ptl) < 0.001 || Number(ptl) > 0.1)) {
        showToast("PTL must be lie between 0.001 to 0.1", 2000, "red");
        return;
      }

      let data = {};
      batchFormData.forEach((row) => {
        const regs = registerMap[row.batch];
        if (!regs) return;
        if (row.set_quantity == "" && row.cut_length == "") return;
        data[regs.set_quantity] = parseInt(row.set_quantity) || 0;
        data[regs.cut_length] = parseFloat(row.cut_length) || 0;
      });

      // Fixed / control registers
      data["D3200"] = 1; // always write 1
      data["D3204"] = parseInt(readLoop) || 1; // Actual Loop, user-editable, can't be 0
      data["D3206"] = materialDiameter !== "" ? parseFloat(materialDiameter) : 0; // Material Diameter
      data["D3208"] = ptl !== "" ? parseFloat(ptl) : 0; // PTL - per tooth load
      data["D3210"] = cutterSpeed !== "" ? parseFloat(cutterSpeed) : 0; // Cutter Speed

      let uploadData = {
        ins: "Write",
        data,
      };

      let url = "https://itlapi.flovation.in/machine/uploadMachineData";
      let body = {
        device_id: batchUpdateDevice,
        uploadData,
      };

      await axios.post(url, body, {
        headers: { 'authorization': `${userdetails.access_token}` },
      }).then(response => {
        const isSuccess = response.status === 200 && response.data.statusCode == 0;

        if (response.status === 200) {
          if (response.data.statusCode != 0) showToast(response.data.msg || "Batch data sent", 3000, "red");
          else showToast(response.data.msg || "Batch data sent", 3000, "green");
        }

        // close modal on any api response, per requirement
        setBatchUpdateState(false);
        setBatchUpdateDevice(null);
        setBatchFormData(emptyBatchData);
        setReadLoop(1);
        resetBatchExtraFields();

        // on success, route to the machine dashboard page
        if (isSuccess) {
          navigate("/dashboard", { state: batchUpdateMachineId });
        }
        setBatchUpdateMachineId(null);
      }).catch(error => {
        console.log("submitBatchUpdate", error);
        if (error.response?.status === 403) {
          showToast("Session Time Out", 3000, "red");
          navigate("/");
        } else {
          showToast("Failed to update batch data", 3000, "red");
        }
        setBatchUpdateState(false);
        setBatchUpdateDevice(null);
        setBatchUpdateMachineId(null);
        setBatchFormData(emptyBatchData);
        setReadLoop(1);
        resetBatchExtraFields();
      });
    } catch (error) {
      console.log("submitBatchUpdate", error);
      setBatchUpdateState(false);
    }
  };

  const is_Warrenty = (Commi_Date) => {
    const today = new Date();
    const commissionDate = new Date(Commi_Date); // make sure Commi_Date is in yyyy-mm-dd

    // difference in milliseconds
    const diffInMs = today - commissionDate;

    if (isNaN(commissionDate)) {
      // invalid date
      return (
        <div style={{ width: 15, height: 15, backgroundColor: "orange", borderRadius: "50%" }}></div>
      );
    }

    // difference in years
    const diffInYears = diffInMs / (1000 * 60 * 60 * 24 * 365.25);

    if (diffInYears < 1) {
      // warranty valid
      return (
        <div style={{ width: 15, height: 15, backgroundColor: "green", borderRadius: "50%" }}></div>
      );
    } else {
      // warranty expired
      return (
        <div style={{ width: 15, height: 15, backgroundColor: "red", borderRadius: "50%" }}></div>
      );
    }
  };

  const isActiveDevice =(data) =>{
    if(data === "Disconnect"){
      return <div style={{ width: 15, height: 15, backgroundColor: "red", borderRadius: "50%" }}></div>
    }
    else return <div style={{ width: 15, height: 15, backgroundColor: "green", borderRadius: "50%" }}></div>
  }


  const debouncedSearch = useCallback(
    debounce((searchTerm) => {
      // console.log("Searching for:", searchTerm);
      // You can call your API here
      getMachineList(searchTerm)
    }, 500),
    [] // only create this once
  );

  useEffect(() => {
    debouncedSearch(searchTerm);
  }, [searchTerm]);


  useEffect(() => {
    // getMachineList()
    UnpairDeviceList()
  }, []);


  return (
    <div style={{ width: "98%", margin: "1%" }}>
      <div className='px-6 py-2 text-lg flex justify-between items-center  client-block'>
        <h1 className="text-xl font-semibold text-center" > Machine Management</h1>
        <div className='flex align-center client-icon-block' style={{ alignItems: "center" }}>
          <div style={{ position: 'relative', height: 40 }}>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                border: '1px solid #9385e3',
                borderRadius: 20,
                padding: '5px 10px',
                width: isExpanded ? 200 : 40,
                transition: 'width 0.3s ease',
                overflow: 'hidden',
                backgroundColor: isExpanded ? 'white' : "#9385e3",
                cursor: 'pointer'
              }}
              onMouseEnter={handleIconClick}
            ><i class="fa fa-search" style={{ color: isExpanded ? "#9385e3" : 'white' }}></i>

              {isExpanded && searchTerm === "" && (
                <span className="search-place">Search...</span>
              )}
              <input
                type="text"
                // placeholder="Search..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                style={{
                  marginLeft: 10,
                  border: 'none',
                  outline: 'none',
                  flex: 1,
                  opacity: isExpanded ? 1 : 0,
                  transition: 'opacity 0.3s ease',
                  backgroundColor: 'transparent'
                }}
              />
            </div>
          </div>
          <div className='px-3 py-1 bg-white borderradius-10 rounded-lg shadow-md border border-gray-300' style={{ margin: "0 5px" }}>
            <i class="fa fa-refresh" data-tooltip-id="my-tooltip1"
              data-tooltip-content="Reset Filter"
              onClick={() => {
                // setSelectedOption("");
                // setSelectedUserStatus("");
                // setSelectedUserComp(userdetails.role === "ADMIN" ? userdetails.comp_num.toString() : "");
                setSearchTerm('');
                setIsExpanded(false)
              }}
            ></i>
          </div>

          {(userdetails.role == "SUPER ADMIN" || userdetails.role == "SUB ADMIN") &&
            <div className='px-3 py-1 bg-white borderradius-10 rounded-lg shadow-md border border-gray-300' style={{ margin: "0 5px" }}>
              <i class="fa fa-plus" data-tooltip-id="my-tooltip-add-machine"
                data-tooltip-content="Add Machine" onClick={() => { setmacineShow(true); setCurrentSection('machine') }}></i>
              <Tooltip id="my-tooltip-add-machine" />
            </div>
          }
        </div>

      </div>
      {
        loaderState ? (
          <Loader />
        )
          :
          MachineList.length === 0 ? (
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "75vh" }}>
              <img
                src={require("../Assets/no_data.png")}
                alt="No Data"
                style={{
                  borderRadius: 20,
                  boxShadow: "0 4px 20px rgba(0, 0, 0, 0.2)",
                }}
              />
            </div>
          ) : (
            <UserTable data={MachineList} handleShiftList={handleShiftList} handleEdit={handleEdit} onView={handleView} downloadCompReport={downloadCompReport} is_Warrenty={is_Warrenty} userdetails={userdetails} onUpdateBatchData={handleUpdateBatchData} isActiveDevice={isActiveDevice} />

          )
      }


      {machineShow && (
        <div className="overlay" >
          <div className="form-box" style={{ width: 900 }}>
            <h2 className="text-xl font-bold mb-4 text-center"> {formData.length !== undefined ? "Add Machine" : "Edit Machine"}</h2>

            {/* Input Fields */}
            <div style={{
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: "center",
              marginBottom: 10,
              width: '100%'
            }}>
              <h2
                style={{
                  margin: "0 20px",
                  fontSize: 16,
                  fontWeight: 600,
                  borderBottom: currentSection === 'machine' ? '2px solid gray' : '2px solid transparent',
                  transition: 'border-bottom 0.3s ease',
                  cursor: 'pointer'
                }}
                onClick={() => setCurrentSection('machine')}
              >
                Machine Details
              </h2>
              <h2
                style={{
                  margin: "0 20px",
                  fontSize: 16,
                  fontWeight: 600,
                  borderBottom: currentSection === 'setup' ? '2px solid gray' : '2px solid transparent',
                  transition: 'border-bottom 0.3s ease',
                  cursor: 'pointer'
                }}
                onClick={() => setCurrentSection('setup')}
              >
                Setup Details
              </h2>
              <h2
                style={{
                  margin: "0 20px",
                  fontSize: 16,
                  fontWeight: 600,
                  borderBottom: currentSection === 'commission' ? '2px solid gray' : '2px solid transparent',
                  transition: 'border-bottom 0.3s ease',
                  cursor: 'pointer'
                }}
                onClick={() => setCurrentSection('commission')}
              >
                Commissioning Details
              </h2>
            </div>


            {currentSection === 'machine' ?
              <>
                <h2
                  style={{
                    margin: "20px 0",
                    width: "100%",
                    fontSize: 16,
                    fontWeight: 600,
                  }}
                >
                  Machine Details
                </h2>
                <div className="flex flex-wrap mx-2 w-full " >

                  {/* MACHINE_NAME */}
                  <div className="relative w-1/2 px-2 mb-4" style={{ width: "48%" }}>
                    <label className="absolute left-2 -top-2 text-red-600 bg-white px-1 text-sm">Machine Name</label>
                    <input
                      required
                      id="machine_name"
                      value={formData.machine_name}
                      onChange={(e) => handleDeviceAdd("machine_name", e.target.value)}
                      className="w-full p-2 border rounded-md focus:ring-2 focus:ring-red-500"
                    />
                  </div>

                  {/* Machine_Model */}
                  <div className="relative w-1/2 px-2 mb-4" style={{ width: "48%" }}>
                    <label className="absolute left-2 -top-2 text-red-600 bg-white px-1 text-sm">Machine Model</label>
                    <input
                      id="Machine_Model"
                      value={formData.Machine_Model}
                      onChange={(e) => handleDeviceAdd("Machine_Model", e.target.value)}
                      className="w-full p-2 border rounded-md focus:ring-2 focus:ring-red-500"
                    />
                  </div>

                  {/* Machine_Serial_Number  */}
                  <div className="relative w-1/2 px-2 mb-4" style={{ width: "48%" }}>
                    <label className="absolute left-2 -top-2 text-red-600 bg-white px-1 text-sm">
                      Machine Serial Number
                    </label>
                    <input
                      id='Machine_Serial_Number'
                      // placeholder="WhatsApp Number"
                      value={formData.Machine_Serial_Number}
                      onChange={(e) => handleDeviceAdd("Machine_Serial_Number", e.target.value)}
                      className="w-full p-2 border rounded-md focus:ring-2 focus:ring-red-500"
                    />
                  </div>

                  {/* Machine_Dispatch_Date  */}
                  <div className="relative w-1/2 px-2 mb-4" style={{ width: "48%" }}>
                    <label className="absolute left-2 -top-2 text-red-600 bg-white px-1 text-sm">
                      Machine Dispatch Date
                    </label>
                    <input
                      type="date"
                      id='Machine_Dispatch_Date'
                      // placeholder="WhatsApp Number"
                      value={formData.Machine_Dispatch_Date}
                      onChange={(e) => handleDeviceAdd("Machine_Dispatch_Date", e.target.value)}
                      className="w-full p-2 border rounded-md focus:ring-2 focus:ring-red-500"
                    />
                  </div>

                  {/* location  */}
                  <div className="relative w-1/2 px-2 mb-4" style={{ width: "48%" }}>
                    <label className="absolute left-2 -top-2 text-red-600 bg-white px-1 text-sm">
                      Machine location
                    </label>
                    <input
                      id='location'
                      // placeholder="WhatsApp Number"
                      value={formData.location}
                      onChange={(e) => handleDeviceAdd("location", e.target.value)}
                      className="w-full p-2 border rounded-md focus:ring-2 focus:ring-red-500"
                    />
                  </div>
                </div>

                <div className="flex justify-end space-x-3 mt-4">
                  <button
                    onClick={() => { setmacineShow(false); setFormData([]); setCurrentSection('machine') }}
                    className="px-4 py-2 bg-gray-300 rounded-md"
                  >
                    Close
                  </button>
                  <button
                    onClick={() => handleSubmitmachine(1)}
                    className="px-4 py-2 bg-blue-500 text-white rounded-md"
                  >
                    Submit
                  </button>
                </div>

              </>
              :
              (currentSection === 'setup' ?
                <>
                  <h2
                    style={{
                      margin: "20px 0",
                      width: "100%",
                      fontSize: 16,
                      fontWeight: 600,
                    }}
                  >
                    Machine Setup Details
                  </h2>

                  <div className="flex flex-wrap mx-2 w-full " >

                    {/* setup_make*/}
                    <div className="relative w-1/2 px-2 mb-4" style={{ width: "48%" }}>
                      <label className="absolute left-2 -top-2 text-red-600 bg-white px-1 text-sm">Setup Make</label>
                      <input
                        id="setup_make"
                        value={formData.setup_make}
                        onChange={(e) => handleDeviceAdd("setup_make", e.target.value)}
                        className="w-full p-2 border rounded-md focus:ring-2 focus:ring-red-500"
                      />
                    </div>

                    {/* HMI ID */}
                    <div className="relative w-1/2 px-2 mb-4" style={{ width: "48%" }}>
                      <label className="absolute left-2 -top-2 text-red-600 bg-white px-1 text-sm">HMI Id</label>
                      <input
                        id="HMI_ID"
                        value={formData.HMI_ID}
                        onChange={(e) => handleDeviceAdd("HMI_ID", e.target.value)}
                        className="w-full p-2 border rounded-md focus:ring-2 focus:ring-red-500"
                      />
                    </div>


                    {/* Index_Servo_Drive  */}
                    <div className="relative w-1/2 px-2 mb-4" style={{ width: "48%" }}>
                      <label className="absolute left-2 -top-2 text-red-600 bg-white px-1 text-sm">
                        Index Servo Drive
                      </label>
                      <input
                        id='Index_Servo_Drive'
                        // placeholder="WhatsApp Number"
                        value={formData.Index_Servo_Drive}
                        onChange={(e) => handleDeviceAdd("Index_Servo_Drive", e.target.value)}
                        className="w-full p-2 border rounded-md focus:ring-2 focus:ring-red-500"
                      />
                    </div>

                    {/* Index_Servo_Motor  */}
                    <div className="relative w-1/2 px-2 mb-4" style={{ width: "48%" }}>
                      <label className="absolute left-2 -top-2 text-red-600 bg-white px-1 text-sm">
                        Index Servo Motor
                      </label>
                      <input
                        id='Index_Servo_Motor'
                        // placeholder="WhatsApp Number"
                        value={formData.Index_Servo_Motor}
                        onChange={(e) => handleDeviceAdd("Index_Servo_Motor", e.target.value)}
                        className="w-full p-2 border rounded-md focus:ring-2 focus:ring-red-500"
                      />
                    </div>

                    {/* Feed_Servo_Drive  */}
                    <div className="relative w-1/2 px-2 mb-4" style={{ width: "48%" }}>
                      <label className="absolute left-2 -top-2 text-red-600 bg-white px-1 text-sm">
                        Feed Servo Drive
                      </label>
                      <input
                        id='Feed_Servo_Drive'
                        // placeholder="WhatsApp Number"
                        value={formData.Feed_Servo_Drive}
                        onChange={(e) => handleDeviceAdd("Feed_Servo_Drive", e.target.value)}
                        className="w-full p-2 border rounded-md focus:ring-2 focus:ring-red-500"
                      />
                    </div>

                    {/* Feed_Servo_Motor  */}
                    <div className="relative w-1/2 px-2 mb-4" style={{ width: "48%" }}>
                      <label className="absolute left-2 -top-2 text-red-600 bg-white px-1 text-sm">
                        Feed Servo Motor
                      </label>
                      <input
                        id='Feed_Servo_Motor'
                        // placeholder="WhatsApp Number"
                        value={formData.Feed_Servo_Motor}
                        onChange={(e) => handleDeviceAdd("Feed_Servo_Motor", e.target.value)}
                        className="w-full p-2 border rounded-md focus:ring-2 focus:ring-red-500"
                      />
                    </div>

                    {/* PLC  */}
                    <div className="relative w-1/2 px-2 mb-4" style={{ width: "48%" }}>
                      <label className="absolute left-2 -top-2 text-red-600 bg-white px-1 text-sm">
                        PLC
                      </label>
                      <input
                        id='PLC'
                        // placeholder="WhatsApp Number"
                        value={formData.PLC}
                        onChange={(e) => handleDeviceAdd("PLC", e.target.value)}
                        className="w-full p-2 border rounded-md focus:ring-2 focus:ring-red-500"
                      />
                    </div>

                    {/* Motion_Module  */}
                    <div className="relative w-1/2 px-2 mb-4" style={{ width: "48%" }}>
                      <label className="absolute left-2 -top-2 text-red-600 bg-white px-1 text-sm">
                        Motion Module
                      </label>
                      <input
                        id='Motion_Module'
                        // placeholder="WhatsApp Number"
                        value={formData.Motion_Module}
                        onChange={(e) => handleDeviceAdd("Motion_Module", e.target.value)}
                        className="w-full p-2 border rounded-md focus:ring-2 focus:ring-red-500"
                      />
                    </div>

                    {/* Input_Module  */}
                    <div className="relative w-1/2 px-2 mb-4" style={{ width: "48%" }}>
                      <label className="absolute left-2 -top-2 text-red-600 bg-white px-1 text-sm">
                        Input Module
                      </label>
                      <input
                        id='Input_Module'
                        // placeholder="WhatsApp Number"
                        value={formData.Input_Module}
                        onChange={(e) => handleDeviceAdd("Input_Module", e.target.value)}
                        className="w-full p-2 border rounded-md focus:ring-2 focus:ring-red-500"
                      />
                    </div>

                    {/* Output_Module  */}
                    <div className="relative w-1/2 px-2 mb-4" style={{ width: "48%" }}>
                      <label className="absolute left-2 -top-2 text-red-600 bg-white px-1 text-sm">
                        Output Module
                      </label>
                      <input
                        id='Output_Module'
                        // placeholder="WhatsApp Number"
                        value={formData.Output_Module}
                        onChange={(e) => handleDeviceAdd("Output_Module", e.target.value)}
                        className="w-full p-2 border rounded-md focus:ring-2 focus:ring-red-500"
                      />
                    </div>

                    {/* Analog_Module  */}
                    <div className="relative w-1/2 px-2 mb-4" style={{ width: "48%" }}>
                      <label className="absolute left-2 -top-2 text-red-600 bg-white px-1 text-sm">
                        Analog Module
                      </label>
                      <input
                        id='Analog_Module'
                        // placeholder="WhatsApp Number"
                        value={formData.Analog_Module}
                        onChange={(e) => handleDeviceAdd("Analog_Module", e.target.value)}
                        className="w-full p-2 border rounded-md focus:ring-2 focus:ring-red-500"
                      />
                    </div>

                    {/* VFD  */}
                    <div className="relative w-1/2 px-2 mb-4" style={{ width: "48%" }}>
                      <label className="absolute left-2 -top-2 text-red-600 bg-white px-1 text-sm">
                        VFD
                      </label>
                      <input
                        id='VFD'
                        // placeholder="WhatsApp Number"
                        value={formData.VFD}
                        onChange={(e) => handleDeviceAdd("VFD", e.target.value)}
                        className="w-full p-2 border rounded-md focus:ring-2 focus:ring-red-500"
                      />
                    </div>
                  </div>

                  {/* Buttons */}
                  <div className="flex justify-end space-x-3 mt-4">
                    <button
                      onClick={() => { setmacineShow(false); setFormData([]); setCurrentSection('machine') }}
                      className="px-4 py-2 bg-gray-300 rounded-md"
                    >
                      Close
                    </button>
                    <button
                      onClick={() => handleSubmitmachine(2)}
                      className="px-4 py-2 bg-blue-500 text-white rounded-md"
                    >
                      Submit
                    </button>
                  </div>

                </>
                :
                <>
                  <h2
                    style={{
                      margin: "20px 0",
                      width: "100%",
                      fontSize: 16,
                      fontWeight: 600,
                    }}
                  >
                    Machine Commission Details
                  </h2>
                  <div className="flex flex-wrap mx-2 w-full " >

                    {/* Machine_Commissioning_Date  */}
                    <div className="relative w-1/2 px-2 mb-4" style={{ width: "48%" }}>
                      <label className="absolute left-2 -top-2 text-red-600 bg-white px-1 text-sm">
                        Machine Commissioning Date
                      </label>
                      <input
                        type="date"
                        id='Machine_Commissioning_Date'
                        // placeholder="WhatsApp Number"
                        value={formData.Machine_Commissioning_Date}
                        onChange={(e) => handleDeviceAdd("Machine_Commissioning_Date", e.target.value)}
                        className="w-full p-2 border rounded-md focus:ring-2 focus:ring-red-500"
                      />
                    </div>
                  </div>

                  <div className="flex justify-end space-x-3 mt-4">
                    <button
                      onClick={() => { setmacineShow(false); setFormData([]); setCurrentSection('machine') }}
                      className="px-4 py-2 bg-gray-300 rounded-md"
                    >
                      Close
                    </button>
                    <button
                      onClick={() => handleSubmitmachine(3)}
                      className="px-4 py-2 bg-blue-500 text-white rounded-md"
                    >
                      Submit
                    </button>
                  </div>
                </>
              )
            }

          </div>


        </div>
      )
      }

      {showShiftData && (
        <div className="overlay" >
          <div className="form-box" style={{ width: 500 }}>
            <h2 className="text-2xl font-bold mb-6 text-center">Shifts</h2>

            <div className="space-y-4">
              <div className="flex justify-end items-center mb-4">
                <button
                  onClick={addShift}
                  className="flex items-center hover:bg-pink-200 transition"
                  style={{ backgroundColor: "pink", padding: "2px 10px", borderRadius: 10 }}
                >
                  <i className="fas fa-plus mr-2 text-sm px-2" /> Add Shift
                </button>
              </div>

              {shiftData.map((shift, index) => (
                <div
                  key={index}
                  className="border rounded-lg p-4 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 items-center"
                >
                  <div className="flex flex-col sm:flex-row gap-4 sm:items-center w-full item-center" style={{ width: "90%", justifyContent: "space-between" }}>
                    <label className="flex flex-col text-sm font-medium item-center" style={{ alignItems: "center" }}>
                      Start Time
                      <input
                        type="time"
                        value={shift.start_time}
                        onChange={(e) => handleTimeChange(index, 'start_time', e.target.value)}
                        className="mt-1 border px-2 py-1 rounded mx-5"
                        style={{ backgroundColor: "rgb(209 213 220)" }}
                      />
                    </label>
                    <label className="flex flex-col text-sm font-medium item-center " style={{ alignItems: "center" }}>
                      End Time
                      <input
                        type="time"
                        value={shift.end_time}
                        onChange={(e) => handleTimeChange(index, 'end_time', e.target.value)}
                        className="mt-1 border px-2 py-1 rounded mx-5"
                        style={{ backgroundColor: "rgb(209 213 220)" }}
                      />
                    </label>
                  </div>
                  <button
                    onClick={() => deleteShift(index)}
                    style={{
                      color: 'rgb(220, 38, 38)',
                      transition: 'color 0.2s ease',
                      fontSize: '0.875rem',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'flex-end',
                      width: '10%',
                    }}
                  >
                    <i
                      className="fas fa-trash shake"
                      style={{
                        marginRight: '0.25rem',
                        padding: '5px 10px',
                        backgroundColor: 'white',
                        border: '1px solid gray',
                        borderRadius: '4px',
                        cursor: 'pointer',
                        boxShadow: '0 2px 6px rgba(0, 0, 0, 0.15)',
                      }}
                    />
                  </button>
                </div>
              ))}
            </div>

            {/* Footer buttons */}
            <div className="flex justify-end gap-4 mt-2">
              <button
                onClick={() => {
                  setShowShiftData(false);
                  setMa_id(undefined);
                }}
                className="flex items-center px-4 py-2 bg-gray-300 text-black rounded hover:bg-gray-400"
                style={{ margin: "10px 5px" }}
              >
                Close
              </button>

              <button
                onClick={() => {
                  updateMachineShift();
                  setShowShiftData(false);
                }}
                className="flex items-center px-4 py-2 bg-gray-300 text-black rounded hover:bg-gray-400"
                style={{ margin: "10px 5px" }}
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      )}

      {
        deviceAssignState && (
          <div className="overlay">
            <div className="form-box">
              <h2 className="text-xl font-bold mb-4 text-center">Assign Device</h2>

              <div className="relative w-full" style={{ margin: "0 10px" }}>
                <select
                  value={selectedDevice}
                  onChange={handlepairDevice}
                  className="w-full p-2 border border-gray-300 rounded-md focus:ring-blue-500 text-gray-700 bg-white appearance-none"
                >
                  <option value="" disabled={true} selected={!selectedDevice}>
                    Select Device to Pair
                  </option>
                  {deviceOption.map((option) => (
                    <option key={option.device_key} value={option.device_id}>
                      Device {1000 + parseInt(option.device_id)}
                    </option>
                  ))}
                </select>
              </div>

              {/* Buttons */}
              <div className="flex justify-end space-x-3 mt-4">
                <button
                  onClick={() => { setDeviceAssignState(false); setMachineDetails({}); setSelectedDevice("") }}
                  className="px-4 py-2 bg-gray-300 rounded-md"
                >
                  Cancel
                </button>
                <button
                  onClick={submitAssignDevice}
                  className="px-4 py-2 bg-blue-500 text-white rounded-md"
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        )
      }

      {batchUpdateState && (
        <div className="overlay">
          <div className="form-box" style={{ width: 550 }}>
            <div className="flex items-center justify-between mb-4">
              <h2 className="text-xl font-bold text-center flex-1">Update Batch Data</h2>
              <button
                onClick={() => {
                  setBatchUpdateState(false);
                  setBatchUpdateDevice(null);
                  setBatchUpdateMachineId(null);
                  setBatchFormData(emptyBatchData);
                  setReadLoop(1);
                  resetBatchExtraFields();
                }}
                className="px-3 py-1 bg-gray-300 rounded-md text-sm ml-4"
              >
                X
              </button>
            </div>

            <div style={{ maxHeight: "50vh", overflowY: "auto" }}>
              <table className="w-full border-collapse">
                <thead>
                  <tr className="bg-gray-200 text-black text-sm">
                    <th className="px-3 py-2 text-left border">Batch</th>
                    <th className="px-3 py-2 text-left border">Cut Length (mm)</th>
                    <th className="px-3 py-2 text-left border">Set Quantity</th>
                    <th className="px-3 py-2 text-center border">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {batchFormData.map((row, index) => (
                    <tr key={row.batch} className="border-b">
                      <td className="px-3 py-2 border font-medium">{`Batch${row.batch}`}</td>
                      <td className="px-3 py-2 border">
                        <input
                          type="number"
                          step="0.01"
                          min="1"
                          max="5000"
                          value={row.cut_length}
                          onChange={(e) => handleBatchFieldChange(index, "cut_length", e.target.value)}
                          className="w-full p-1 border rounded-md focus:ring-2 focus:ring-blue-500"
                        />
                      </td>
                      <td className="px-3 py-2 border">
                        <input
                          type="number"
                          min="0"
                          max="999999"
                          value={row.set_quantity}
                          onChange={(e) => handleBatchFieldChange(index, "set_quantity", e.target.value)}
                          className="w-full p-1 border rounded-md focus:ring-2 focus:ring-blue-500"
                        />
                      </td>
                      <td className="px-3 py-2 border text-center">
                        {index === batchFormData.length - 1 ? (
                          <>
                            <i
                              className="fas fa-trash text-red-600 cursor-pointer"
                              data-tooltip-id="my-tooltip-delete-batch"
                              data-tooltip-content="Remove Row"
                              onClick={() => deleteBatchRow(index)}
                            ></i>
                            <Tooltip id="my-tooltip-delete-batch" />
                          </>
                        ) : (
                          <i
                            className="fas fa-trash text-gray-300"
                            style={{ cursor: "not-allowed" }}
                          ></i>
                        )}
                      </td>
                    </tr>
                  ))}
                  {batchFormData.length === 0 && (
                    <tr>
                      <td colSpan={4} className="px-3 py-4 border text-center text-gray-500">
                        No batches left
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            <div className="flex flex-wrap gap-4 mt-4">
              <div className="relative w-1/2 mt-4">
                <label className="absolute left-2 -top-2 text-red-600 bg-white px-1 text-sm">
                  Actual Loop
                </label>
                <input
                  type="number"
                  min="1"
                  value={readLoop}
                  onChange={(e) => handleReadLoopChange(e.target.value)}
                  className="w-full p-2 border rounded-md focus:ring-2 focus:ring-red-500"
                />
              </div>

              {/* PTL - per tooth load (D3208) - zero allowed, float allowed, negative not allowed */}
              <div className="relative w-1/2 mt-4">
                <label className="absolute left-2 -top-2 text-red-600 bg-white px-1 text-sm">
                  PTL (per tooth load)
                </label>
                <input
                  type="number"
                  value={ptl}
                  onChange={(e) => handleReadPTLChange(e.target.value)}
                  className="w-full p-2 border rounded-md focus:ring-2 focus:ring-red-500"
                />
              </div>

              {/* Cutter Speed (D3210) - zero allowed, float allowed, negative not allowed */}
              <div className="relative w-1/2 mt-4">
                <label className="absolute left-2 -top-2 text-red-600 bg-white px-1 text-sm">
                  Saw Speed
                </label>
                <input
                  type="number"
                  step="any"
                  min="50"
                  max="200"
                  value={cutterSpeed}
                  onChange={(e) => handleReadSawSpeedChange(e.target.value)}
                  className="w-full p-2 border rounded-md focus:ring-2 focus:ring-red-500"
                />
              </div>
            </div>

            <div className="flex justify-end space-x-3 mt-4">
              <button
                onClick={() => {
                  setBatchUpdateState(false);
                  setBatchUpdateDevice(null);
                  setBatchUpdateMachineId(null);
                  setBatchFormData(emptyBatchData);
                  setReadLoop(1);
                  resetBatchExtraFields();
                }}
                className="px-4 py-2 bg-gray-300 rounded-md"
              >
                Close
              </button>
              <button
                onClick={submitBatchUpdate}
                className="px-4 py-2 bg-blue-500 text-white rounded-md"
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      )}

      {downloadReportState && (
        <div className="overlay">
          <div className="form-box">
            <div className="flex items-center justify-between mb-4">
              <h2 className="text-xl font-bold text-center flex-1">Report Download</h2>
              <button
                onClick={() => setDownloadReportState(false)}
                className="px-3 py-1 bg-gray-300 rounded-md text-sm ml-4"
              >
                X
              </button>
            </div>
            <Report bodyData={RowData.current} onDownloadSuccess={handleCloseModal} />
          </div>
        </div>
      )}
      {/* <Footer /> */}
    </div >
  )
}

export default Machine